import {Message, Portal} from "semantic-ui-react"
import {FormattedMessage} from "react-intl"


/**
 * Shows a dismissable error message in the bottom left corner of the screen.
 */
interface ErrorPopupProps { message?: string | Error, open: boolean, onDismiss: () => void }
export function ErrorPopup(props: ErrorPopupProps) {
    const content = props.message instanceof Error ? props.message.message : props.message
    return (
        <Portal open={props.open} onClose={props.onDismiss}>
            <Message negative className="error-popup" onDismiss={props.onDismiss}>
                <Message.Header><FormattedMessage id="error.unknown"/></Message.Header>
                <p>{content}</p>
            </Message>
        </Portal>
    )
}